import { User } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import queryClient from '@/lib/queryClient';

/**
 * 1231. 受注案件担当候補ユーザ一覧
 * [GET] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/target_users
 */
type Props = {
  identifier: string;
  team_id: number;
  id: number;
};

const salesOrderTargetUsers = (props: Props): Promise<User[]> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.id}/target_users`);
};

export const useSalesOrderTargetUsers = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => salesOrderTargetUsers(props),
  });
};

export const useSalesOrderTargetUsersInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: queryKey(props),
    });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return ['workspaces', props.identifier, 'teams', props.team_id, 'sales_orders', props.id, 'target_users'];
};
